(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ept-preorder-control"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ept-preorder-control')) {
    customElements.define(
      'ept-preorder-control',
      class EptPreorderControl extends HTMLElement {
        connectedCallback() {
          this.releaseDate = new Date(this.dataset.releaseAt);

          if (Number.isNaN(this.releaseDate.getTime()) || this.releaseDate <= new Date()) {
            this.remove();
            return;
          }

          this.localizeReleaseDate();
          this.productRoot = this.closest('.product-details, product-info, [data-product-id], section') || document;
          this.preventSubmission = (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
          };

          this.applyState();
          this.observer = new MutationObserver(() => this.queueApply());
          this.observer.observe(this.productRoot, { childList: true, subtree: true });
        }

        localizeReleaseDate() {
          const previousDisplay = this.dataset.releaseDisplay;
          if (!previousDisplay) return;
          const display = new Intl.DateTimeFormat(document.documentElement.lang || 'nl-NL', {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          }).format(this.releaseDate);
          for (const key of ['blockedButton', 'deliveryMessage', 'availabilityMessage']) {
            this.dataset[key] = (this.dataset[key] || '').replaceAll(previousDisplay, display);
          }
          this.querySelectorAll('[data-ept-dated-text]').forEach((element) => {
            element.textContent = element.textContent.replaceAll(previousDisplay, display);
          });
          this.dataset.releaseDisplay = display;
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        queueApply() {
          if (this.applyQueued) return;
          this.applyQueued = true;
          requestAnimationFrame(() => {
            this.applyQueued = false;
            this.applyState();
          });
        }

        applyState() {
          const forms = this.productRoot.querySelectorAll('form[action*="/cart/add"]');

          forms.forEach((form) => {
            const button = form.querySelector('[data-btn-addtocart], button[name="add"], button[type="submit"]');
            form.querySelectorAll('.shopify-payment-button').forEach((element) => {
              element.hidden = true;
            });

            if (this.dataset.mode === 'blocked') {
              form.addEventListener('submit', this.preventSubmission, true);
              if (button) {
                button.disabled = true;
                button.setAttribute('aria-disabled', 'true');
                if (button.textContent.trim() !== this.dataset.blockedButton) {
                  button.textContent = this.dataset.blockedButton;
                }
              }
              return;
            }

            if (button && button.textContent.trim() !== this.dataset.preorderButton) {
              button.textContent = this.dataset.preorderButton;
            }

            this.upsertInput(form, `properties[${this.dataset.linePropertyName}]`, this.dataset.deliveryMessage);
            this.upsertInput(form, 'properties[_preorder_release_at]', this.dataset.releaseAt);
          });

          this.replaceDeliveryMessage();
          this.replaceAvailabilityMessage();
        }

        upsertInput(form, name, value) {
          let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((element) => element.name === name);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            form.append(input);
          }
          input.value = value;
        }

        replaceDeliveryMessage() {
          const candidates = this.productRoot.querySelectorAll('.product__text, [data-delivery-message]');
          candidates.forEach((element) => {
if (!/(vandaag|morgen|bezorg|lever|levertijd|werkdag)/i.test(element.textContent)) return;
            const textTarget = element.querySelector('span') || element;
            if (textTarget.textContent.trim() !== this.dataset.deliveryMessage) {
              textTarget.textContent = this.dataset.deliveryMessage;
            }
          });
        }

        replaceAvailabilityMessage() {
          const candidates = this.productRoot.querySelectorAll('.popup-title, [data-stock-status]');
          candidates.forEach((element) => {
            if (!/(op voorraad|in voorraad|voorraad in)/i.test(element.textContent)) return;
            if (element.textContent.trim() !== this.dataset.availabilityMessage) {
              element.textContent = this.dataset.availabilityMessage;
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
